/* Calendar or business days in Japan, independent of the visitor's timezone and DST. */
(() => {
  if (customElements.get('dispatch-estimate')) return;
  const DAY = 86400000;
  const JST = 9 * 3600000;
  class DispatchEstimate extends HTMLElement {
    connectedCallback() {
      this.update = this.update.bind(this);
      this.update();
      this.timer = setInterval(this.update, 60000);
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.update);
    }
    update() {
      const min = Number(this.dataset.minDays);
      const max = Number(this.dataset.maxDays);
      if (![min, max].every(n => Number.isInteger(n) && n >= 0 && n <= 60) || max < min) {
        this.hidden = true;
        this.style.display = 'none';
        return;
      }
      const today = Math.floor((Date.now() + JST) / DAY) * DAY;
      // Business days skip Saturday and Sunday (JST); holidays are counted as business days.
      const addDays = (count) => {
        if (this.dataset.businessDays !== 'true') return today + count * DAY;
        let t = today;
        while (count > 0) { t += DAY; const w = new Date(t).getUTCDay(); if (w !== 0 && w !== 6) count--; }
        return t;
      };
      const start = new Date(addDays(min));
      const end = new Date(addDays(max));
      const lang = this.dataset.locale || 'ja';
      const includeYear = start.getUTCFullYear() !== new Date(today).getUTCFullYear() || end.getUTCFullYear() !== start.getUTCFullYear();
      // English uses short months and a compact range: "Nov 13 – 15" / "Nov 28 – Dec 2" (2026-10-31)
      const isEnglish = !['ja', 'ko'].includes(lang) && !lang.startsWith('zh');
      const format = new Intl.DateTimeFormat(lang, {
        timeZone: 'UTC', month: isEnglish ? 'short' : 'long', day: 'numeric', ...(includeYear ? { year: 'numeric' } : {})
      });
      const from = format.format(start);
      const to = format.format(end);
      let range = min === max ? from : `${from}${lang === 'ja' ? '〜' : ' – '}${to}`;
      if (isEnglish && min !== max && format.formatRange) range = format.formatRange(start, end);
      const label = lang === 'ja' ? `${range}頃に発送予定`
        : lang === 'ko' ? `${range} 발송 예정`
        : lang.startsWith('zh') ? `預計 ${range} 出貨`
        : `Estimated dispatch: ${range}`;
      this.querySelector('[data-dispatch-date]').textContent = label;
    }
  }
  customElements.define('dispatch-estimate', DispatchEstimate);
})();
